import React, { useMemo } from "react";
import { Typography } from "@mui/material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";

import { objectToFormData } from "../../../../utils";
import FormDialog from "../../../../components/Dialog/FormDialog";
import { currentUserId } from "../../../../utils/constants";
import CustomMenuItem from "../../../../components/Menu/CustomMenuItem";
import { useUserMutationDialog } from "../hooks/useUserMutationDialog";
import { getActiveDialogContent } from "../utils/userManagementUtils";

function Active({ isActive, userId, onMenuClose = () => {} }) {
  const currentUser = currentUserId();
  const isCurrentUser = String(currentUser) === String(userId);
  const activeDialog = useUserMutationDialog({
    userId,
    initialValue: isActive,
    createPayload: (status) => objectToFormData({ active: !status }),
    getNextValue: (status) => !status,
  });
  const dialogContent = useMemo(
    () => getActiveDialogContent(activeDialog.value),
    [activeDialog.value]
  );

  return (
    <>
      {!isCurrentUser && (
        <CustomMenuItem
          onClick={() => {
            if (!isCurrentUser) {
              activeDialog.openDialog();
              onMenuClose();
            }
          }}
        >
          <PersonOffOutlinedIcon className="user-management-action-icon mr-2"/>
          <p>{activeDialog.value ? "Disable" : "Enable"}</p>
          {activeDialog.isDialogOpen && (
            <FormDialog
              open={activeDialog.isDialogOpen}
              handleClose={activeDialog.closeDialog}
              isLoading={activeDialog.isSubmitting}
              handleSubmit={activeDialog.submit}
              buttonTxt={dialogContent.buttonText}
              cancelBtn={true}
              title={dialogContent.title}
            >
              <Typography className="align_text_center mb-2 ">
                {dialogContent.message}
              </Typography>
            </FormDialog>
          )}
        </CustomMenuItem>
      )}
    </>
  );
}

export default React.memo(Active);
